import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnterBirthDateComponent } from './components/enter-birth-date/enter-birth-date.component';
import {
  FinancialMonitoringInfoComponent
} from './components/financial-monitoring-info/financial-monitoring-info.component';
import { ForbiddenPaymentComponent } from './components/forbidden-payment/forbidden-payment.component';

@NgModule({
  declarations: [
    EnterBirthDateComponent,
    FinancialMonitoringInfoComponent,
    ForbiddenPaymentComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    EnterBirthDateComponent,
    FinancialMonitoringInfoComponent,
    ForbiddenPaymentComponent,
  ],
})
export class FinancialMonitoringModule { }
